import { Mark } from "@tiptap/core";

export interface HighlightMarkOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    highlightMark: {
      toggleHighlightMark: () => ReturnType;
    };
  }
}

export const HighlightMark = Mark.create<HighlightMarkOptions>({
  name: "highlightMark",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  inclusive: false,

  parseHTML() {
    return [
      {
        tag: "mark",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["mark", HTMLAttributes, 0];
  },

  addCommands() {
    return {
      toggleHighlightMark:
        () =>
        ({ commands }) => {
          if (this.editor.isActive("highlightMark")) {
            return commands.unsetMark("highlightMark");
          } else {
            return commands.setMark("highlightMark");
          }
        },
    };
  },
});
